import React, { Component } from 'react';
import { SegmentGroup, Segment, Header, Table, Button, Loader, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

class SspList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: { studyProgramQuestionnaireDTOS: [] }
        };
    }

    componentDidMount() {
        // eslint-disable-next-line no-unused-expressions
        localStorage.removeItem('pollType');
        localStorage.removeItem('spId');
        localStorage.removeItem('spbId');
        localStorage.removeItem('spName');
        localStorage.removeItem('spbName');
        axios.get(`questionnaire/studyProgramDTO/statistics/${JSON.parse(localStorage.getItem('poll')).pollId}/`).then((res) => {
            this.setState({ data: res.data, loading: false });
        });
    }

    render() {
        return (
            <div>
                <Header as="H1">
                    Ankete
                </Header>
                <SegmentGroup raised clearing>

                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                Studijski programi
                            </Header.Content>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('poll')) === 'null' ? ' ' : JSON.parse(localStorage.getItem('poll')).pollName}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>

                        {this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> : <Table celled selectable compact fixed >
                                <Table.Header>
                                    <Table.Row >


                                        <Table.HeaderCell colSpan="2">Naziv</Table.HeaderCell>
                                        <Table.HeaderCell >Broj studenata na završnoj godini</Table.HeaderCell>
                                        <Table.HeaderCell > Broj studenata koji su pristupili anketi</Table.HeaderCell>
                                        <Table.HeaderCell > Prosjek </Table.HeaderCell>

                                        <Table.HeaderCell verticalAlign="middle" textAlign="center">Rezultati</Table.HeaderCell>


                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.state.data && this.state.data.studyProgramQuestionnaireDTOS.map((el, index) =>
                                        (<Table.Row
                                            key={index}
                                            onClick={(e) => {
                                                this.setState({ showResults: true });
                                            }}
                                        >

                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                <Grid columns={1} centered className="stackable">
                                                    <Grid.Row verticalAlign="middle">
                                                        <Grid.Column width="10">
                                                            <span><b>{el.studyProgramBasic.name}</b> {' | ' + el.studyProgram.name}</span>
                                                        </Grid.Column>
                                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                            <span style={{ color: '#a6a4a1' }}>{el.studyCycle}</span>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </Table.Cell>

                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudentsOnLastYear}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudentsWhoAnswered}
                                            </Table.Cell>
                                            <Table.Cell
                                                verticalAlign="middle"
                                                warning={parseFloat(el.averageGrade).toFixed(2) >= 2 && parseFloat(el.averageGrade).toFixed(2) <= 4}
                                                positive={parseFloat(el.averageGrade).toFixed(2) > 4}
                                                negative={parseFloat(el.averageGrade).toFixed(2) < 2}
                                            >
                                                {el.averageGrade ? parseFloat(el.averageGrade).toFixed(2) : '-' }
                                            </Table.Cell>

                                            <Table.Cell verticalAlign="middle" textAlign="center" >
                                                {/* link */}

                                                <Button
                                                    onClick={() => {
                                                        localStorage.setItem('pollType', 'ssp');
                                                        localStorage.setItem('spId', el.studyProgram.id);
                                                        localStorage.setItem('spbId', el.studyProgramBasic.id);
                                                        localStorage.setItem('spName', el.studyProgram.name);
                                                        localStorage.setItem('spbName', el.studyProgramBasic.name);
                                                    }}
                                                    disabled={!el.numberOfStudentsOnLastYear || !el.numberOfStudentsWhoAnswered}
                                                    basic="true"
                                                    color="blue"
                                                    size="small"
                                                > <Link to={{
                                                        pathname: '/ankete/sp/rezultati',

                                                    }}
                                                > Tabelarni prikaz
                                                </Link>
                                                </Button>
                                                {/* <Link to={{ */}
                                                {/*    pathname: '/ankete/osoblje/predmeti/grafički-prikaz', */}

                                                {/* }} */}
                                                {/* > */}
                                                {/* <Button */}
                                                {/*    onClick={() => { */}
                                                {/*        localStorage.setItem('courseId', el.courseImplementationId); */}
                                                {/*        localStorage.setItem('courseName', el.courseImplementationName); */}
                                                {/*        localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse); */}
                                                {/*        localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee); */}
                                                {/*    }} */}
                                                {/*    disabled={!el.numberOfStudentsWhoRatedCourse && !el.numberOfStudentsWhoRatedEmployee} */}
                                                {/*    basic="true" */}
                                                {/*    color="green" */}
                                                {/*    size="small" */}
                                                {/* >  Grafički prikaz */}

                                                {/* </Button> */}
                                                {/* </Link> */}

                                            </Table.Cell>
                                        </Table.Row>))}
                                </Table.Body>
                            </Table>}
                    </Segment>
                </SegmentGroup>
            </div>
        );
    }
}

export default SspList;



// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/SspPoll/SSPList.js